import React, { useContext, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import DayPicker from 'react-day-picker';

import { Layout, Text } from "components";
import ListQuotes from "components/ListQuotes/listQuotes";
import Colors from "constants/Colors";
import { Button } from "components/index";
import { Col, Row } from "components/Grid";
import { InputField, SelectField } from 'components/Form';
import Loader from "components/Loader";

import { GlobalAuthContext, GlobalLoaderContext } from "store/context";

import { FitinsurAPI, MessageCenter } from "utils";

import { LoadContainer, NewEnquiryButtons, HeaderContainer, CalendarContainer, Label, Icon } from "./styles";

export default function List() {
  // main execution
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const history = useHistory();

  // refs
  const formik = useRef(Formik);

  // context
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);

  // states
  const [showCalendar, setCalendar] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [dateFilter, setDateFilter] = useState("");
  const [sortBy, setSortBy] = useState({
    key: null,
    direction: null,
  });
  const [filtered, setFiltered] = useState(false);

  ////////////////////////////////////////////////////////////////

  const pluck = key => array => Array.from(new Set(array.map(obj => obj[key])));

  const getProductsFilter = pluck('productName');

  const getStatusFilter = pluck('statusDescription');

  const initialValues = {
    idOperation: "",
    operationDate: "",
    productName: "",
    personLastNameInsured: "",
    statusDescription: "",
  };

  const columns = [
    {
      title: "NÚMERO DA COTAÇÃO",
      value: "idOperation",
      md: 2,
      sm: 1,
    },
    {
      title: "DATA DE CRIAÇÃO",
      value: "operationDate",
      md: 2,
    },
    {
      title: "TIPO DE PRODUTO",
      value: "productName",
      md: 2,
    },
    {
      title: "NOME DO PROPONENTE",
      value: "personLastNameInsured",
      md: 2,
    },
    {
      title: "SITUAÇÃO DA COTAÇÃO",
      value: "statusDescription",
      md: 2,
    },
    {
      title: "SLA",
      value: "sla",
      md: 1,
    },
  ];
  const situations = [
    {
      label: 'Em andamento',
      value: 'Em andamento'
    },
    {
      label: 'Ag. Info adicionais',
      value: 'Ag. Info adicionais'
    },
    {
      label: 'Ag. emissão',
      value: 'Ag. emissão'
    },
    {
      label: 'Emitida',
      value: 'Emitida'
    },
  ];
  const MONTHS = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];
  const WEEKDAYS_LONG = [
    "Segunda-Feira",
    "Terça-Feira",
    "Quarta-Feira",
    "Quinta-Feira",
    "Sexta-Feira",
    "Sábado",
    "Domingo",
  ];
  const WEEKDAYS_SHORT = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"];

  async function resetFilters(event) {
    formik.current.resetForm(initialValues);
    setDateFilter('');
    setPageNumber(1);
    setFiltered(false);

  };

  function filterClick(e) {
    console.log("filter Click", e)
    e.stopPropagation();
    e.preventDefault();
    setFiltered(true);
    getList();
  };

  ////////////////////////////////////////////////////////////////

  useEffect(() => {
    if (filtered === false) {
      formik.current.resetForm(initialValues);
      setDateFilter('');
      setPageNumber(1);
      getList();
    };
  }, [filtered]);

  useEffect(() => {
    console.log(authContext);
    if (authContext.status !== true) {
      mc.error("User is not authenticated, please Login");
      // history.push("login");
    } else {
      fitinsur.setAuthToken(authContext.token);
      getList();
    }
  }, []);

  const newEnquiry = (idProduct) => history.push(`/quotes/info/${idProduct}`)

  const handleNavigation = (value) => {

    // Rota para acessar view das respostas dos questionarios
    history.push(`/quotes/info/${value.idProduct}/${value.idOperation}`, { productName: value.productName });


    /*  
    ToDo ajustar esquema de navegação lista multi-cliente
    switch (value.idDomainStatus) {
      case 1:
        history.push(`/quotes/plans/${value.idProduct}/${value.idOperation}`);
        break;
      case 4:
        history.push(`/quotes/payments/${value.idProduct}/${value.idOperation}`);
        break;
      case 5:
        history.push(`/documents/${value.idProduct}/${value.idOperation}`);
        break;
      case 6:
        history.push(`/documents/${value.idProduct}/${value.idOperation}`);
        break;
      case 7:
        history.push(`/quotes/info/${value.idProduct}/${value.idOperation}`);
        break;
      default:
        console.log('erro na navegacao', value);
        return;
    } */

  }

  function nextPage() {
    if (pageNumber === totalPages) return;

    let contPage = pageNumber + 1;
    setPageNumber(contPage);
    getList(contPage, sortBy);
  }

  function handleSortList(key) {
    let direction = "desc";
    if (sortBy.key === key && sortBy.direction === "desc") direction = "asc";
    const sort = { key, direction };

    setSortBy(sort);
    if (key === "sla" && direction === "asc")
      return setData(data.sort((a, b) => (a.sla > b.sla ? 1 : -1)));
    if (key === "sla" && direction === "desc")
      return setData(data.sort((a, b) => (b.sla > a.sla ? 1 : -1)));

    setPageNumber(1);
    return getList(1, sort);
  }

  function jsonToQueryString(json) {
    return Object.keys(json)
      .map((key) =>
        json && json[key] !== ""
          ? encodeURIComponent(key) + "=" + encodeURIComponent(json[key]) + "&"
          : ""
      )
      .join("");
  }

  function getList(page = 1, sort = {}) {
    loading.start();
    const operationDate = dateFilter && dateFilter.length ? `&operationDate=${dateFilter}` : "";
    console.log("dados formik", formik.current.values);
    const queryString = jsonToQueryString(formik.current?.values);

    console.log('String do filtro ', queryString)
    const url = `?sortBy=${JSON.stringify(sort)}&${queryString}page=${page}${operationDate}`;

    fitinsur.setAuthToken(authContext.token);
    fitinsur
      .requestListQuotesAction(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          loading.stop();
          return;
        }
        setData(data.ret_value);
        setTotalPages(data.pagination_control.totalPages);
        loading.stop();
      })
      .catch((err) => {
        console.log(err);
        loading.stop();
      });
  }

  const handleNewEnquiry = () => (
    <>
      <Text
        primary
        type="button"
        style={{ cursor: "pointer" }}
        onClick={() => window.open('www.transporteseguro.com.br', '_blank')}
      >
        + NOVA COTAÇÃO
      </Text>
    </>
  );

  return (
    <Layout title="Cotações" subtitle={handleNewEnquiry()}>
      <HeaderContainer>
        <Formik
          innerRef={formik}
          initialValues={initialValues}
          onSubmit={() => null}
        >
          {(formikProps) => (
            <Form>
              <Row>
                <Col md={2} xm={12}>
                  <Field
                    name="idOperation"
                    placeholder="Número de cotação"
                    value={formikProps.values.idOperation}
                    onChange={(e) =>
                      formikProps.setFieldValue("idOperation", e)
                    }
                    component={InputField}
                  />
                </Col>

                <Col md={2} xm={12}>
                  <Field
                    name="date"
                    value={formikProps.values.date}
                    placeholder="Data de Criação"
                    rightIcon="calendar"
                    rightIconClick={() => setCalendar(!showCalendar)}
                    type="text"
                    readOnly
                    component={InputField}
                  />

                  {showCalendar ? (
                    <CalendarContainer>
                      <DayPicker
                        style
                        fixedWeeks
                        onDayClick={(date) => {
                          formikProps.setFieldValue(
                            "date",
                            new Date(date).toLocaleDateString("en-GB")
                          );
                          setDateFilter(
                            `${new Date(date).getFullYear()}-${Number(new Date(date).getMonth() + 1) >= 10
                              ? new Date(date).getMonth() + 1
                              : `0${new Date(date).getMonth() + 1}`
                            }-${new Date(date).getDate() < 10
                              ? `0${new Date(date).getDate()}`
                              : new Date(date).getDate()}`
                          );
                          setCalendar(false);
                        }}
                        months={MONTHS}
                        weekdaysLong={WEEKDAYS_LONG}
                        weekdaysShort={WEEKDAYS_SHORT}
                        firstDayOfWeek={0}
                      />
                    </CalendarContainer>
                  ) : null}
                </Col>

                <Col md={2} xm={12}>
                  <Field
                    placeholder="Produto"
                    name="productName"
                    value={formikProps.values.productName}
                    type="text"
                    readOnly
                    options={getProductsFilter(data).map(item => ({ label: item, value: item }))}
                    component={SelectField}
                  />
                </Col>

                <Col md={2} xm={12}>
                  <Field
                    placeholder="Proponente"
                    name="personLastNameInsured"
                    value={formikProps.values.personLastNameInsured}
                    onChange={(e) =>
                      formikProps.setFieldValue("personLastNameInsured", e)
                    }
                    component={InputField}
                  />
                </Col>

                <Col md={2} xm={12}>
                  <Field
                    placeholder="Situação da Cotação"
                    name="statusDescription"
                    value={formikProps.values.statusDescription}
                    type="text"
                    readOnly
                    // options={getStatusFilter(data).map(item => ({ label: item, value: item }))}
                    options={situations}
                    component={SelectField}
                  />
                </Col>

                <Col md={2} xm={6} style={{ direction: "rtl", justifyContent: "center", alignItems: "center" }}>
                  <Icon
                    name="filterCan"
                    style={{ cursor: "pointer", padding: "10px 0px 0px 0px" }}
                    onClick={(e) => {
                      setDateFilter('');
                      resetFilters(e)
                    }}
                  />
                  <Icon
                    name="filter"
                    style={{ cursor: "pointer", padding: "10px 10px 0px 10px" }}
                    onClick={(e) => filterClick(e)}
                  />
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </HeaderContainer>

      <ListQuotes
        columns={columns}
        data={data}
        handleSortList={handleSortList}
        sortBy={sortBy}
        navigation={handleNavigation}
      />
      {loading.active ? (
        <Loader backdropColor={Colors.WHITE} fullScreen />
      ) : (
        <LoadContainer>
          {!data || data.length === 0 ? (
            <Button forth onClick={(e) => e.preventDefault()}>
              AINDA NÃO FOI REALIZADA NENHUMA COTAÇÃO
            </Button>
          ) : (
            <Button forth onClick={() => nextPage()}>
              {pageNumber === totalPages
                ? "NÃO HÁ MAIS COTAÇÕES PARA MOSTRAR"
                : "CARREGAR MAIS COTAÇÕES"}
            </Button>
          )}
        </LoadContainer>
      )}
    </Layout>
  );
}
